import { formatMoney, getOrderFinancials } from "./orderWorkspaceFormatters";
import styles from "./OrdersWorkspace.module.css";

export default function OrderFinancialSummary({ order, totalOnly = false }) {
  const { subtotal, discount, delivery, total, advancePaid, amountReceivable } = getOrderFinancials(order);
  const hasAdvance = advancePaid != null && advancePaid > 0 && amountReceivable != null && advancePaid < amountReceivable;
  const remainingCod = hasAdvance ? amountReceivable - advancePaid : null;
  const rows = totalOnly
    ? [
        ...(hasAdvance ? [{ label: "Advance paid", value: advancePaid }] : []),
        ...(hasAdvance ? [{ label: "Remaining (COD)", value: remainingCod }] : []),
        { label: "Order total", value: total, total: true },
      ]
    : [
        { label: "Items subtotal", value: subtotal, optional: true },
        { label: "Discounts", value: discount, optional: true },
        { label: "Delivery", value: delivery, optional: true },
        ...(hasAdvance ? [{ label: "Advance paid", value: advancePaid }] : []),
        ...(hasAdvance ? [{ label: "Remaining (COD)", value: remainingCod }] : []),
        { label: "Order total", value: total, total: true },
      ];

  return (
    <div className={styles.financialSummary}>
      {rows.map((row) =>
        row.optional && !(row.value > 0) ? null : (
          <div className={`${styles.financialRow} ${row.total ? styles.financialTotal : ""}`} key={row.label}>
            <span>{row.label}</span>
            <strong>{formatMoney(row.value)}</strong>
          </div>
        )
      )}
    </div>
  );
}
